<app-modal [isOpen]="isOpen" [className]="'max-w-3xl p-6 sm:p-8'" (close)="close()">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">{{ title }}</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">{{ subtitle }}</p>
    </div>

    <form (ngSubmit)="onSubmit()">
        <div class="space-y-5">

            <!-- TIPO DE PERSONA / DOC TYPE / DOC NUMBER -->
            <div class="grid grid-cols-1 gap-5 sm:grid-cols-12">
                <div class="sm:col-span-4">
                    <app-label>Tipo de persona <span class="text-error-500">*</span></app-label>
                    <app-select [options]="personTypeOptions" placeholder="Seleccione tipo" [(value)]="personTypeId"
                        (valueChange)="onPersonTypeChange($event)"></app-select>
                    @if (submitted && !personTypeId) {
                    <p class="mt-1 text-sm text-error-500">El tipo de persona es obligatorio</p>
                    }
                </div>
                <div class="sm:col-span-4">
                    <app-label>Tipo de documento <span class="text-error-500">*</span></app-label>
                    <app-select [options]="documentTypeOptions" [(value)]="documentTypeId"
                        placeholder="Seleccione tipo de doc." [loading]="loadingDocumentTypes"
                        loadingText="Cargando..." [disabled]="disabledDocumentType"></app-select>
                    @if (submitted && !documentTypeId) {
                    <p class="mt-1 text-sm text-error-500">El tipo de documento es obligatorio</p>
                    }
                </div>
                <div class="sm:col-span-4">
                    <app-label>Número de documento <span class="text-error-500">*</span></app-label>
                    <div class="flex">
                        <input type="text" [(ngModel)]="documentNumber" name="documentNumber"
                            placeholder="Ingrese número de documento"
                            class="h-11 w-full min-w-0 rounded-l-lg border border-r-0 border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
                        <button type="button" [disabled]="!canLookup || isLookingUp" (click)="lookupDocument()"
                            title="Consultar documento"
                            class="flex h-11 items-center justify-center rounded-r-lg border border-gray-300 bg-gray-50 px-3 text-gray-500 transition-colors hover:bg-gray-100 hover:text-brand-600 disabled:cursor-not-allowed disabled:opacity-40 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700">
                            @if (isLookingUp) {
                            <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                            </svg>
                            } @else {
                            <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <circle cx="11" cy="11" r="8" />
                                <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35" />
                            </svg>
                            }
                        </button>
                    </div>
                    @if (submitted && !documentNumber) {
                    <p class="mt-1 text-sm text-error-500">El número de documento es obligatorio</p>
                    }
                </div>
            </div>

            <!-- AGENTE DE RETENCIÓN -->
            <div>
                <app-checkbox label="Agente de retención" [checked]="isLegalPersonSelected && retentionAgent"
                    [disabled]="!isLegalPersonSelected" (checkedChange)="retentionAgent = $event"></app-checkbox>
                @if (!isLegalPersonSelected) {
                <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Solo aplica para personas jurídicas.</p>
                }
            </div>

            <!-- NATURAL PERSON -->
            @if (isNaturalPerson()) {
            <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
                <div>
                    <app-label>Nombres <span class="text-error-500">*</span></app-label>
                    <app-input-field [(value)]="firstName" name="firstName" placeholder="Ingrese nombres" />
                    @if (submitted && !firstName) {
                    <p class="mt-1 text-sm text-error-500">Los nombres son obligatorios</p>
                    }
                </div>
                <div>
                    <app-label>Apellidos <span class="text-error-500">*</span></app-label>
                    <app-input-field [(value)]="lastName" name="lastName" placeholder="Ingrese apellidos" />
                    @if (submitted && !lastName) {
                    <p class="mt-1 text-sm text-error-500">Los apellidos son obligatorios</p>
                    }
                </div>
            </div>
            }

            <!-- LEGAL PERSON -->
            @if (isLegalPerson()) {
            <div class="grid grid-cols-1 gap-5 sm:grid-cols-12">
                <div class="sm:col-span-8">
                    <app-label>Razón social <span class="text-error-500">*</span></app-label>
                    <app-input-field [(value)]="businessName" name="businessName" placeholder="Ingrese razón social" />
                    @if (submitted && !businessName) {
                    <p class="mt-1 text-sm text-error-500">La razón social es obligatoria</p>
                    }
                </div>
                <div class="sm:col-span-4">
                    <app-label>Contacto</app-label>
                    <app-input-field [(value)]="contactPersonName" name="contactPersonName" placeholder="Nombre de contacto" />
                </div>
            </div>
            }

            <!-- CONTACT INFO -->
            <div class="grid grid-cols-1 gap-5 sm:grid-cols-12">
                @if (isNaturalPerson()) {
                <div class="sm:col-span-4">
                    <app-label>Fecha de nacimiento</app-label>
                    <app-date-picker
                        placeholder="Seleccionar fecha"
                        [defaultDate]="birthDate || undefined"
                        (dateChange)="birthDate = $event.dateStr">
                    </app-date-picker>
                </div>
                }
                <div class="sm:col-span-4">
                    <app-label>Teléfono 1 <span class="text-error-500">*</span></app-label>
                    <div class="flex">
                        <app-phone-picker [(value)]="countryCode1" class="w-22.5 shrink-0"></app-phone-picker>
                        <input type="text" [(ngModel)]="phone1" name="phone1" placeholder="Ej: 999888777"
                            [maxlength]="getPhoneMaxLength(countryCode1)"
                            class="h-11 w-full min-w-0 rounded-r-lg border border-l-0 border-gray-300 bg-transparent px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
                    </div>
                    @if (submitted && !phone1) {
                    <p class="mt-1 text-sm text-error-500">El teléfono es obligatorio</p>
                    } @else if (submitted && phone1 && phone1.length !== getPhoneMaxLength(countryCode1)) {
                    <p class="mt-1 text-sm text-error-500">Debe tener {{ getPhoneMaxLength(countryCode1) }} dígitos</p>
                    }
                </div>
                <div class="sm:col-span-4">
                    <app-label>Teléfono 2</app-label>
                    <div class="flex">
                        <app-phone-picker [(value)]="countryCode2" class="w-22.5 shrink-0"></app-phone-picker>
                        <input type="text" [(ngModel)]="phone2" name="phone2" placeholder="Opcional"
                            [maxlength]="getPhoneMaxLength(countryCode2)"
                            class="h-11 w-full min-w-0 rounded-r-lg border border-l-0 border-gray-300 bg-transparent px-3 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
                    </div>
                </div>
                <div [class]="isLegalPerson() ? 'sm:col-span-4' : 'sm:col-span-6'">
                    <app-label>Correo 1</app-label>
                    <app-input-field [(value)]="email1" name="email1" placeholder="correo@dominio.com" />
                </div>
                <div [class]="isLegalPerson() ? 'sm:col-span-4' : 'sm:col-span-6'">
                    <app-label>Correo 2</app-label>
                    <app-input-field [(value)]="email2" name="email2" placeholder="Opcional" />
                </div>
            </div>

            <!-- ADDRESSES -->
            <div class="pt-4 border-t border-gray-100 dark:border-gray-800">
                <h4 class="mb-3 text-sm font-semibold text-gray-700 dark:text-gray-300">Direcciones</h4>
                @if (createAddresses.length > 0) {
                <div class="mb-3 space-y-2">
                    @for (a of createAddresses; track $index; let idx = $index) {
                    <div class="flex items-center gap-2">
                        <div class="flex flex-1 flex-col justify-center rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-800">
                            <span class="text-sm text-gray-700 dark:text-gray-300">{{ a.address }}</span>
                            @if (a.ubigeo || a.description) {
                            <span class="mt-0.5 text-xs text-gray-400 dark:text-gray-500">
                                @if (a.ubigeo) { {{ a.ubigeo }} }
                                @if (a.ubigeo && a.description) { · }
                                @if (a.description) { {{ a.description }} }
                            </span>
                            }
                        </div>
                        <button type="button" (click)="removeCreateAddress(idx)"
                            class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-red-300 text-white hover:bg-red-400">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z" fill="white"/>
                            </svg>
                        </button>
                    </div>
                    }
                </div>
                }
                <div class="space-y-2">
                    <input type="text" [(ngModel)]="newCreateAddrAddress" name="newCreateAddrAddress"
                        placeholder="Nueva dirección (ej. Av. Principal 123)"
                        class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30" />
                    <div class="flex flex-col gap-2 sm:flex-row sm:items-center">
                        <div class="flex-1 min-w-0">
                            <app-ubigeo-picker [(value)]="newCreateAddrUbigeo" [ubigeos]="allUbigeos"
                                [loading]="loadingUbigeos" placeholder="Ubigeo (opcional)"></app-ubigeo-picker>
                        </div>
                        <input type="text" [(ngModel)]="newCreateAddrDescription" name="newCreateAddrDescription"
                            placeholder="Descripción"
                            class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30 sm:w-36" />
                        <button type="button" (click)="addCreateAddress()" [disabled]="!newCreateAddrAddress.trim()"
                            class="inline-flex h-9 items-center justify-center rounded-lg bg-brand-500 px-3 text-sm text-white hover:bg-brand-600 disabled:opacity-50 whitespace-nowrap">
                            Agregar dirección
                        </button>
                    </div>
                </div>
            </div>

            <!-- ACTIONS -->
            <div class="flex items-center justify-end gap-3 pt-2 border-t border-gray-100 dark:border-gray-800">
                <button type="button" (click)="close()"
                    class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                    Cancelar
                </button>
                <button type="submit" [disabled]="isSubmitting"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50">
                    {{ isSubmitting ? 'Registrando...' : 'Registrar y seleccionar' }}
                </button>
            </div>

        </div>
    </form>

</app-modal>
